import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  email: z
    .string()
    .email('Invalid email address')
    .min(1, 'Required')
});
